import { useEffect } from 'react'
import { globalActionRegistry, createAction } from '@appic/command-palette'

const ERP_NAV_ENTRIES: ReadonlyArray<{
  id: string
  label: string
  href: string
  keywords: string[]
  shortcut: string
}> = [
  { id: 'nav:dashboard', label: 'Open Dashboard', href: '/dashboard', keywords: ['dashboard', 'home'], shortcut: 'g d' },
  { id: 'nav:sales', label: 'Open Sales Orders', href: '/sales/orders', keywords: ['sales', 'orders'], shortcut: 'g s' },
  { id: 'nav:purchase', label: 'Open Purchase Orders', href: '/purchase/orders', keywords: ['purchase', 'orders'], shortcut: 'g p' },
  { id: 'nav:inventory', label: 'Open Inventory', href: '/inventory/items', keywords: ['inventory', 'items'], shortcut: 'g i' },
]

function buildErpActions() {
  const navActions = ERP_NAV_ENTRIES.map((entry) =>
    createAction(
      entry.id,
      entry.label,
      () => {
        window.location.href = entry.href
      },
      { category: 'Workspace', keywords: entry.keywords, shortcut: entry.shortcut },
    ),
  )
  const helpAction = createAction(
    'help:shortcuts',
    'Show Keyboard Shortcuts',
    () => {
      void 0 // keyboard shortcuts action registered for command palette
    },
    { category: 'Global', keywords: ['help', 'shortcuts'] },
  )
  return [...navActions, helpAction]
}

/**
 * Registers ERP navigation entries (Dashboard, Sales, Purchase, Inventory) and
 * the keyboard-shortcuts hint with the global Command Palette registry. The
 * registry is a global singleton, so the effect must unregister on unmount to
 * avoid duplicate entries across HMR reloads and remount cycles.
 */
export function useErpPaletteActions(): void {
  useEffect(() => {
    const actions = buildErpActions()
    actions.forEach((a) => globalActionRegistry.register(a))
    return () => actions.forEach((a) => globalActionRegistry.unregister(a.id))
  }, [])
}
